import { PRODUCT_ROUTE_PARAM } from '@/constants/routes'
import type { DataGroupType } from '@/types/datagroup'
import { isAgencyDatagroup } from '@/utils/platform'

// URL parsing helpers
const parseURL = (url: string) => {
  const [pathname, search] = url.split('?')
  const pathParts = pathname.split('/').filter(Boolean)
  return {
    [PRODUCT_ROUTE_PARAM]: pathParts[0] || '',
    dashboardId: pathParts[2] || '',
    queryParams: new URLSearchParams(search || ''),
  }
}

// Event properties extractors
const getAgencyProperties = (url: string) => {
  const { [PRODUCT_ROUTE_PARAM]: product, dashboardId, queryParams } = parseURL(url)
  return {
    application: product,
    country: queryParams.get('country') ?? undefined,
    dashboard_id: dashboardId,
    retailer: queryParams.get('retailer') ?? undefined,
    timestamp: Date.now(),
    url,
  }
}

const getBrandProperties = (url: string) => {
  const { [PRODUCT_ROUTE_PARAM]: product, dashboardId } = parseURL(url)
  return {
    application: product,
    dashboard_id: dashboardId,
    timestamp: Date.now(),
    url,
  }
}

export const getPropertiesFromURL = (url: string, datagroupType: DataGroupType) => {
  return isAgencyDatagroup(datagroupType)
    ? getAgencyProperties(url)
    : getBrandProperties(url)
}

// Key filters from URL (Brand: store, CMI: retailer)
export const getKeyFiltersFromURL = (url: string, datagroupType: DataGroupType) => {
  const { queryParams } = parseURL(url)
  const country = queryParams.get('country') || 'ALL'

  if (isAgencyDatagroup(datagroupType)) {
    return { country, retailer: queryParams.get('retailer') ?? undefined }
  }
  const store = queryParams.get('store_name') || queryParams.get('store') || 'ALL'
  return { country, store }
}

// Key filters from JSON (used in filter_applied event)
export const getKeyFiltersFromFiltersJson = (
  filtersJson: string,
  datagroupType: DataGroupType,
) => {
  try {
    const { country, store_name, retailer, ...rest } = JSON.parse(filtersJson)

    if (isAgencyDatagroup(datagroupType)) {
      return {
        country: country || 'ALL',
        retailer,
        cleanedFilters: JSON.stringify(rest),
      }
    }
    return {
      country: country?.length > 0 ? country : 'ALL',
      store: store_name?.length > 0 ? store_name : 'ALL',
      cleanedFilters: JSON.stringify(rest),
    }
  } catch {
    return { country: 'ALL', store: 'ALL', cleanedFilters: filtersJson }
  }
}
